import router from '@/routers'
import axios from 'axios'
import Vue from 'vue'
import CryptoJS from 'crypto-js'
import ResCache, { KeyMove } from '@/utils/cache-for-res'
// import LoginAPI from '@/api/index.js'
import Tionencryp from '@/utils/h5-notification'
import Util from '@/utils/Util'

const resCacheList = new ResCache()
var qs = require('qs')

// 设置接口错误重试参数
axios.defaults.retry = 1 // 重试次数
axios.defaults.retryDelay = 500 // 重试等待时间

// axios.defaults.headers.get['content-type'] = 'application/json;charset=UTF-8'
axios.interceptors.response.use(config => {
  // // config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  // if (config.method === 'get') {
  //   config.data = {unused: 0} // 这个是关键点，加入这行就可以了
  // }
  return config
})

// 添加请求拦截器
axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

const Utils = {
  get(url, data = {}) {
    // 前端接口超时拦截
    this.actionGuard(data)
    // 调用SHOP_DOMAIN加token
    let token = localStorage.getItem('token')
    if (token && process.env.DOMAIN !== process.env.SHOP_DOMAIN && url.includes(process.env.SHOP_DOMAIN)) {
      data.token = token
    }
    return new Promise((resolve, reject) => {
      let params = Object.assign({}, this.getProcessData(data, url))
      if (params.useCache) delete params.useCache
      if (params.noErrorTips) delete params.noErrorTips
      if (params.noActionTips) delete params.noActionTips

      params.shopId = localStorage.getItem('shopId') || Util.getCookie('shopId')
      params.cycode = Util.getCookie('currencyId') || ''
      let cashResItem = resCacheList.getCache(url, params)
      if (data.useCache && data.useCache.includes('get') && cashResItem) {
        resolve(cashResItem)
        return false
      }
      let config = {
        params,
        withCredentials: true
      }

      axios.get(url, config)
        .then(function (response) {
          if (response.data.code !== 1010 && !data.noErrorTips) {
            // 存当前操作时间戳, 做前端过期时间校验
            let actionDate = new Date().getTime()
            localStorage.setItem('actionDate', actionDate)
          }
          if (response.data.code === 1010) {
            // console.log('没有权限')
            localStorage.removeItem('isLogin')
            localStorage.setItem('currHref', window.location.href)
            window.location.href = '/' // 正式环境登录页
            // window.location.href = '//' + window.location.host
            // router.push({ path: '/' })
          } else if (response.data.code === 0) {
            if (data.useCache && data.useCache.includes('set')) {
              delete data.useCache
              resCacheList.setCache(url, data, response)
            }
            resolve(response)
          } else if (response.data.code === -1) {
            new Vue().$message.error('页面出错了，请稍后再试')
          } else if (/.*\/static\/mock\/.*\.json/.test(url)) {
            resolve(response)
          } else {
            // console.log('接口返回状态码：' + response.data.code)
            /**
             * noErrorMsg 不提示msg的情况
             * @param  {[type]} response.data.message !             [description]
             * @return {[type]}                       [description]
             */
            let noErrorMsg = data.noErrorTips || response.data.message === '未升级用户，不能访问，请与服务人员联系，申请升级服务！' || response.data.data === false
            if (!noErrorMsg && response.data.message) {
              new Vue().$message.error(response.data.message)
              if (response.data.message === '当前登录账号无该联系人的操作权限') {
                router.push({ path: '/index' })
              }
              resolve(response)
            } else {
              resolve(response)
            }
          }
        })
        .catch(function (error) {
          reject(error)
          // console.log(error)
        })
    })
  },
  post(url, data = {}, upload = false, type) {
    // 前端接口超时拦截
    this.actionGuard(data)
    let token = localStorage.getItem('token')
    if (token && process.env.DOMAIN !== process.env.SHOP_DOMAIN && url.includes(process.env.SHOP_DOMAIN)) {
      data.token = token
    }
    return new Promise((resolve, reject) => {
      let params = Object.assign({}, this.getProcessData(data, url))
      if (params.useCache) delete params.useCache
      if (params.noErrorTips) delete params.noErrorTips
      if (params.noActionTips) delete params.noActionTips
      params.shopId = localStorage.getItem('shopId') || Util.getCookie('shopId')
      params.cycode = Util.getCookie('currencyId') || ''
      let dataP = {
        withCredentials: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      }
      if (url.includes('/bshop/contacts/excel/export')) {
        dataP.responseType = 'blob'
      }
      params = upload || type === 'json' ? params : qs.stringify(params)
      if (type === 'json') {
        dataP.headers = {
          'Content-Type': 'application/json;charset=UTF-8',
        }
      }
      axios.post(url, params, dataP)
        .then(function (response) {
          if (response.data.code !== 1010 && !data.noErrorTips) {
            let actionDate = new Date().getTime()
            localStorage.setItem('actionDate', actionDate)
          }
          if (response.data.code === 1010) {
            // console.log('没有权限')
            window.location.href = '//' + window.location.host
          } else if (response.data.code === 0) {
            // if (data.useCache && data.useCache.includes('set')) {
            //   delete data.useCache
            //   resCacheList.setCache(url, data, response)
            // }
            resolve(response)
          } else {
            /**
             * 未升级用户，不能访问，请与服务人员联系，申请升级服务！  这句 不提示
             * @param  {[type]} response.data.message !             [description]
             * @return {[type]}                       [description]
             * noErrorMsg 不提示信息
             */
            let noErrorMsg = data.noErrorTips || response.data.message === '未升级用户，不能访问，请与服务人员联系，申请升级服务！' || response.data.message === '用户未绑定社交账号' || response.data.message === 'emailfail' || response.data.data === false
            if (!noErrorMsg && response.data.message) {
              new Vue().$message.error(response.data.message)
              resolve(response)
            } else {
              resolve(response)
            }
          }
        })
        .catch(function (error) {
          reject(error)
          // console.log(error)
        })
    })
  },
  // 前端超时缓存拦截方法
  actionGuard(data) {
    if (!data || data.noActionTips) {
      return false
    } else {
      let expiredDate = new Date().getTime() - 2 * 60 * 50 * 1000
      let actionDate = localStorage.getItem('actionDate') || 0
      if (!actionDate || (actionDate < expiredDate)) {
        // LoginAPI.logOut({noActionTips: 1}).then(() => {
        //   localStorage.clear()
        //   let corpId = this.GetQueryString('corpId')
        //   window.location.href = '//' + window.location.host + '/#/login?corpId=' + corpId
        //   return false
        // })
      } else {
        return false
      }
    }
  },
  // 接口参数处理
  getProcessData(data, url) {
    let params = JSON.parse(JSON.stringify(data))
    // 字段处理
    let keyArr = Tionencryp.tionencrypStr()
    let keyMove = KeyMove()
    let key = Util.b64DecodeUnicode(keyArr.join('TQzN'))
    key = CryptoJS.enc.Hex.parse(key)
    let iv = CryptoJS.enc.Hex.parse(Util.Noitpyrcne(keyMove))
    let publicKey = '4561230789ACEGIK7891234560LOONXI'
    let greenwich = new Date().getTime()
    let enc = CryptoJS.AES.encrypt(greenwich + publicKey, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    params.appointTimeStamp = greenwich
    params.conventionSecret = enc.ciphertext.toString()
    // 海关数据接口统一添加userId 和 mainUserId字段
    if (url.indexOf(process.env.CUSTOMS_DOMAIN) !== -1) {
      let user = JSON.parse(localStorage.getItem('user') || '{}')
      params.userId = user.userId || ''
      params.mainUserId = user.parentUserId || user.userId
    }
    return params
  },
  GetQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r !== null) return unescape(r[2])
  }
}

export default Utils
